import React, { useEffect, useState } from "react";
import InitialSetupWizard from "./InitialSetupWizard";
import DialogLayout from "../../partials/content/DialogLayout";
import { Typography } from "@material-ui/core";
import { Image } from "react-bootstrap";
import { Carousel } from "primereact/carousel";
import { getCompanyProfile } from "../../services/setup/company-profile/companyProfileService";
import { toAbsoluteUrl } from "../../../_metronic/utils/utils";
import LoginForm from "./LoginForm";
import { useGlobalData } from "../../../provider/GlobalDataProvider";
function Login() {
  const { companyProfileTheme } = useGlobalData();
  const [openInitialSetupWizard, setOpenInitialSetupWizard] = useState(false);
  const [companyProfile, setCompanyProfile] = useState({});
  const [companyProfileImgSrc, setCompanyProfileImgSrc] = useState(null);
  const [products, setProducts] = useState([
    {
      image: "/invifo/illustrations/INVIFO CRM.png",
    },
    {
      image: "/invifo/illustrations/INVIFO Sales.png",
    },
    {
      image: "/invifo/illustrations/INVIFO Inventory.png",
    },
    {
      image: "/invifo/illustrations/INVIFO Procurement.png",
    },
    {
      image: "/invifo/illustrations/INVIFO Payment.png",
    },
    {
      image: "/invifo/illustrations/INVIFO Ecommerce.png",
    },
    {
      image: "/invifo/illustrations/INVIFO Advertising.png",
    },
    {
      image: "/invifo/illustrations/INVIFO Setup.png",
    },
  ]);

  const productTemplate = (product) => {
    return (
      <div className="product-item">
        <div className="product-item-content">
          <Image
            src={toAbsoluteUrl(`${product.image}`)}
            alt="Invifo Product Image"
            fluid
          />
        </div>
      </div>
    );
  };

  useEffect(() => {
    getCompanyData();
  }, []);

  function getCompanyData() {
    getCompanyProfile().then((response) => {
      const { data } = response.data;
      let companyProfile = data.companyProfile;
      if (
        companyProfile.globalCustomerID === 0 ||
        companyProfile.licenseKey === "" ||
        companyProfile.companyName === ""
      ) {
        setOpenInitialSetupWizard(true);
      } else {
        if (companyProfile.companyProfileLogo.length > 0) {
          setCompanyProfileImgSrc(
            companyProfile.companyProfileLogo[0].imagePath
          );
        }
      }
      setCompanyProfile(companyProfile);
    });
  }

  return (
    <>
      <div className="login-layout">
        <div className="row py-3">
          <div className="col-sm-6 col-md-6 col-lg-6">
            <LoginForm />
          </div>
          <div className="col-sm-6 col-md-6 col-lg-6">
            {companyProfileTheme.ID === 0 ? (
              <div className="d-flex justify-content-center">
                <div className="column">
                  <div className="col-sm-12 col-md-12 col-lg-12">
                    <div className="row justify-content-center">
                      <div className="col-sm-12 col-md-12 col-lg-12">
                        <React.Fragment>
                          <Typography component="span" align="center">
                            <div className="carousel">
                              <Carousel
                                value={products}
                                numVisible={1}
                                numScroll={1}
                                className="custom-carousel"
                                circular
                                autoplayInterval={3000}
                                itemTemplate={productTemplate}
                              />
                            </div>
                          </Typography>
                        </React.Fragment>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </div>
      <DialogLayout
        open={openInitialSetupWizard}
        title="Initial Setup Wizard"
        minHeight={true}
      >
        <InitialSetupWizard
          onConfirmComplete={() => {
            setOpenInitialSetupWizard(false);
            getCompanyData();
          }}
        />
      </DialogLayout>
    </>
  );
}

export default Login;
